<!-- eslint-disable @typescript-eslint/no-explicit-any -->
<template>
  <div class="message-list-container">
    <div class="language-section">
      <h2>{{ t('applicationMessages.English') }}</h2>
      <textarea v-model="enMessagesString" readonly rows="20" class="message-textarea"></textarea>
    </div>
    <div class="language-section">
      <h2>{{ t('applicationMessages.Spanish') }}</h2>
      <textarea v-model="esMessagesString" readonly rows="20" class="message-textarea"></textarea>
    </div>
    <div class="language-section">
      <h2>{{ t('applicationMessages.French') }}</h2>
      <textarea v-model="frMessagesString" readonly rows="20" class="message-textarea"></textarea>
    </div>
    <div class="language-section">
      <h2>{{ t('applicationMessages.German') }}</h2>
      <textarea v-model="deMessagesString" readonly rows="20" class="message-textarea"></textarea>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { enMessages } from "@/assets/enMessages";
import { esMessages } from "@/assets/esMessages";
import { frMessages } from "@/assets/frMessages";
import { deMessages } from "@/assets/deMessages";
import { ref, onMounted } from "vue";

const { t } = useI18n()

// Create refs for message strings
const enMessagesString = ref("");
const esMessagesString = ref("");
const frMessagesString = ref("");
const deMessagesString = ref("");

// Function to convert nested object to string with indentation
function objectToString(obj: any, parentKey = ""): string {
let result = '';

for (const key in obj) {
  const currentKey = parentKey ? `${parentKey}.${key}` : key;
  const prefixedKey = `aoe.${currentKey}`;

  if (typeof obj[key] === 'object' && obj[key] !== null) {
    result += objectToString(obj[key], currentKey);
  } else {
    result += `INSERT INTO NLSMESSAGE ([NLSMESSAGEGUID], [SHASESSIONGUID], [LASTMODIFIEDTIME], [CDDCODEGUID], [MESSAGEID], [MESSAGETEXT]) VALUES (DBO.NewAspireID(NEWID(),GETDATE()), 45830, GETDATE(), 59170529521161354500427538797, '${prefixedKey}', '${escapeStringForSql(obj[key])}')\n`
  }
}

return result;
}

function escapeStringForSql(value: string): string {
return value.replace(/'/g, "''");
}

function objectToStringForeign(obj: any, parentKey = "", nlsCultureGuid : string): string {
let result = '';

for (const key in obj) {
  const currentKey = parentKey ? `${parentKey}.${key}` : key;
  const prefixedKey = `aoe.${currentKey}`;

  if (typeof obj[key] === 'object' && obj[key] !== null) {
    result += objectToStringForeign(obj[key], currentKey, nlsCultureGuid);
  } else {
    result += `INSERT INTO NLSMESSAGEFOREIGN ([NLSMESSAGEFOREIGNGUID], [SHASESSIONGUID], [LASTMODIFIEDTIME], [MESSAGEID], [MESSAGETEXT], [NLSCULTUREGUID]) VALUES (DBO.NewAspireID(NEWID(),GETDATE()), 45830, GETDATE(), '${prefixedKey}', '${escapeStringForSql(obj[key])}', ${nlsCultureGuid})\n`
  }
}

return result;
}

// Generate strings on component mount
onMounted(() => {
  enMessagesString.value = objectToString(enMessages);
  esMessagesString.value = objectToStringForeign(esMessages,"", "29331076328423728211798313654");
  frMessagesString.value = objectToStringForeign(frMessages,"", "33026380019054050574974038599");
  deMessagesString.value = objectToStringForeign(deMessages,"", "48118789410127907921964715932");
});
</script>

<style lang="scss" scoped>
.message-list-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: $spacing-5;
  padding: $card-padding;
}

.language-section {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.message-textarea {
  font-family: monospace;
  width: 100%;
  padding: $spacing-2-5;
  border: 1px solid #cccccc;
  border-radius: $radius-sm;
  white-space: pre;
  overflow-x: auto;
}

h2 {
  margin-bottom: 10px;
}
</style>
